module.exports = __webpack_public_path__ + "img/14-small.dec98195.png";